import { Container } from '../common/Container';
import Link from 'next/link';

export default function TalentBank() {
  return (
    <Container className={'px-3 flex items-center justify-center'}>
      <div className="bg-gray-200 flex flex-col max-w-[930px] justify-center items-center gap-3 p-10 rounded-md text-gray-500">
        <p className="text-center sm:text-2xl">
          Não encontrou a vaga ideal? Então, venha fazer parte do nosso banco de talentos!
        </p>
        <Link href={'/talentbank'} className="px-4 py-2 text-white rounded-md bg-primary">
          Participar do banco de talentos
        </Link>
      </div>
    </Container>
  );
}
